module.exports = __webpack_public_path__ + "img/home_banner_mb.935659fa.webp";